//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CloudDM.js";
import "../no/TransientObject.js";
let d=[[[0,"DateModified",0,0],[0,"DocumentUrn",0,0],[0,"FileSize",0,0],[0,"LastSavedClientId",0,0],[0,"LockInfo",0,0],[0,"Name",0,0],[0,"Owner",0,0],[0,"RevisionUrn",0,0]],[[[],"Dispose",{},0,0]],[]];
SPLM.CloudDM.DocumentIdentifier = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CloudDM.DocumentIdentifier";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CloudDM.DocumentIdentifier.LockInformation = class{
    constructor(lockedAt,lockExpires,lockedBy){
        this.lockedAt=lockedAt;this.lockExpires=lockExpires;this.lockedBy=lockedBy;}
    get Lockedat(){return this.lockedAt}
    set Lockedat(val){this.lockedAt = val}
    get Lockexpires(){return this.lockExpires}
    set Lockexpires(val){this.lockExpires = val}
    get Lockedby(){return this.lockedBy}
    set Lockedby(val){this.lockedBy = val}
};

export default SPLM;